module.exports = __webpack_public_path__ + "img/upload.8475e45b.svg";